import { useEffect } from 'react'
import { redtailSettingsDefaultValues, RedtailSettingsFormValues } from './model'
import { Controller, useForm } from 'react-hook-form'
import { Col, Container, Form, Row, Stack } from 'react-bootstrap'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { FormFeedback } from '../../../../../components/Form/FormFeedback'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { Link } from 'react-router-dom'
import { Button } from '../../../../../components/Button/Button'
import { useRedtailCalendarSync } from './hooks'

export const RedtailCalendarSyncSettings: React.FC = () => {
  const { autoSync, isFetching, isSaving, save } = useRedtailCalendarSync()

  const form = useForm<RedtailSettingsFormValues>({ defaultValues: redtailSettingsDefaultValues })

  useEffect(() => {
    form.setValue('inbound.calendar.enabled', autoSync)
  }, [autoSync, form])

  const onSubmit = async (data: RedtailSettingsFormValues) => {
    await save(data.inbound.calendar.enabled)
  }

  const handleCancel = () => {
    form.reset()
  }

  if (isFetching) {
    return (
      <Container>
        <div className='skeleton mb-2' style={{ width: '100%', height: '70px' }} />
        <div className='skeleton mb-3' style={{ width: '100%', height: '70px' }} />
      </Container>
    )
  }

  return (
    <Container>
      <h6>Calendar</h6>
      <Row className='mb-1 mt-3'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div>Synchronize your calendar automatically</div>
          </Stack>
        </Col>
        <Col md='auto'>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <Controller
              name='inbound.calendar.enabled'
              control={form.control}
              render={({ field, fieldState }) => (
                <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
                  <Form.Switch checked={field.value === true} onChange={field.onChange} />
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </ScopedBlock>
              )}
            />
          </Stack>
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col>
          <div className='paragraph-medium zocks-text-gray-600'>
            Settings related to filtering by <strong>type</strong> and <strong>category</strong> are available on the{' '}
            <Link className='button-link-medium zocks-text-primary cursor-pointer' to='/account/profile-settings/meeting-assistant'>
              Event Filters
            </Link>{' '}
            page.
          </div>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          <div className='d-flex gap-3 justify-content-end mb-4'>
            <Button variant='secondary' onClick={handleCancel} disabled={isSaving}>
              Reset
            </Button>
            <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
              <Button variant='primary' onClick={form.handleSubmit(onSubmit)} loading={isSaving}>
                Save
              </Button>
            </ScopedBlock>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
